import React from 'react';
import { AnchorWithLink } from 'atoms/Anchor';
import { withRouter } from 'react-router-dom';
import FOOTER_CONSTANT from '../FooterConstants/FooterConstant';

const {
  PRIVACY_POLICY,
  OUR_ADS,
  INSTAGRAM,
  TWITTER,
  FACEBOOK,
  FAQ,
  GETHELP,
  TERMS_OF_USE,
  GIFT_CARD,
  ORDER_LOOKUP_NAME,
  CONTACT_US,
  KFC_FEEDBACK,
  EXTERNAl,
} = FOOTER_CONSTANT;

/**
 * List Item Component
 */
export const ListItems = props => {
  const { linkTo = '', name, dataTestId = '', onClickHandler, internalurl = '', externalurl = '' } = props;
  let hrefLink = '';
  let target = '';
  let type = ';';

  switch (name) {
    case INSTAGRAM: {
      hrefLink = '';
      target = '_blank';
      type = 'external';
      break;
    }
    case FACEBOOK: {
      hrefLink = '';
      target = '_blank';
      type = 'external';
      break;
    }
    case TWITTER: {
      hrefLink = '';
      target = '_blank';
      type = 'external';
      break;
    }
    default:
      break;
  }

  switch (props.children) {
    case PRIVACY_POLICY: {
      hrefLink = '/privacyPolicy';
      break;
    }
    case OUR_ADS: {
      hrefLink = '/ourAds';
      break;
    }
    case TERMS_OF_USE: {
      hrefLink = '/terms-of-use';
      break;
    }
    case GETHELP: {
      hrefLink = '/help';
      break;
    }
    case GIFT_CARD: {
      hrefLink = '/giftcards';
      break;
    }
    case ORDER_LOOKUP_NAME: {
      hrefLink = '';
      break;
    }
    case FAQ: {
      hrefLink = '/faq';
      break;
    }
    case CONTACT_US: {
      hrefLink = '/contactus';
      break;
    }
    case KFC_FEEDBACK: {
      if (internalurl) {
        hrefLink = internalurl;
        type = 'internal';
      } else if (externalurl) {
        hrefLink = externalurl;
        target = '_blank';
        type = 'external';
      }
      break;
    }
    default: {
      if (internalurl) {
        hrefLink = internalurl;
        type = 'internal';
      } else if (externalurl) {
        hrefLink = externalurl;
        target = '_blank';
        type = 'external';
      } else {
        hrefLink = linkTo;
      }
      break;
    }
  }

  const ClickHandler = e => {
    if (e.name === INSTAGRAM || e.name === FACEBOOK || e.name === TWITTER) {
      return;
    } else if (e.name === KFC_FEEDBACK && e.type === EXTERNAl) {
      return;
    } else if (props.children === TERMS_OF_USE) {
      window.scrollTo(0, 0);
    } else if (props.children === FAQ) {
      window.scrollTo(0, 0);
    } else if (props.children === GIFT_CARD) {
      window.scrollTo(0, 0);
    } else {
      onClickHandler(e);
    }
    return false;
  };

  return (
    <li>
      <AnchorWithLink
        className='support-links-menu'
        href={hrefLink}
        name={name}
        targetWindow={target}
        onClickHandler={ClickHandler}
        tabIndex='0'
        data-testid={dataTestId}
        type={type}
      >
        {props.children}
      </AnchorWithLink>
    </li>
  );
};

export default withRouter(ListItems);
